import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { MyContext } from "../../Context/MyProvider";

export default function HomeCareBookings() {
  const { ApiBaseUrl, setIsLoginShow } = useContext(MyContext);
  const [filter, setFilter] = useState("upcoming");
  const [bookings, setBookings] = useState([]);
  const navigate = useNavigate();
  const Userid = secureLocalStorage.getItem("Userid");

  useEffect(() => {
    if (!Userid) { setIsLoginShow(true); return; }
    axios.post(`${ApiBaseUrl}/hc/customer/bookings`, { customer_id: Userid, filter })
      .then((r) => setBookings(r.data.bookings || []));
  }, [filter, Userid, ApiBaseUrl, setIsLoginShow]);

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold text-rm-ink mb-4">My Home Visits</h1>
      <div className="flex gap-2 mb-4 flex-wrap">
        {["upcoming", "completed", "cancelled", "past", ""].map((f) => (
          <button key={f || "all"} className={`px-3 py-1 rounded ${filter === f ? "bg-rm-primary text-white" : "bg-gray-100"}`}
            onClick={() => setFilter(f)}>{f || "all"}</button>
        ))}
      </div>
      <div className="space-y-3">
        {bookings.map((b) => (
          <div key={b.id} className="border rounded-xl p-4 bg-white flex justify-between items-center cursor-pointer"
            onClick={() => navigate(`/home-care/booking/${b.id}`)}>
            <div>
              <p className="text-xs text-rm-primary">{b.booking_code}</p>
              <h3 className="font-semibold">{b.service_name}</h3>
              <p className="text-sm text-gray-600">{b.schedule_date} {b.schedule_time} · {b.provider_name || "Finding provider…"}</p>
            </div>
            <div className="text-right">
              <p className="text-sm">{b.status}</p>
              <p className="font-bold">₹{b.total_amount}</p>
            </div>
          </div>
        ))}
        {!bookings.length && <p className="text-center text-gray-500 py-8">No bookings.</p>}
      </div>
    </div>
  );
}
